<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
import Avatar from 'next/avatar/Avatar.vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
  inbox: {
    type: Object,
    required: true,
  },
});

const reauthorizationRequired = computed(() => {
  return props.inbox.reauthorization_required;
});

const inboxAvatarUrl = computed(
  () => props.inbox.avatar_url || props.inbox.avatarUrl || ''
);

const isApiInbox = computed(
  () =>
    props.inbox.channel_type === 'Channel::Api' ||
    props.inbox.channelType === 'Channel::Api'
);
</script>

<template>
  <Avatar
    v-if="isApiInbox && inboxAvatarUrl"
    :name="label"
    :src="inboxAvatarUrl"
    :size="20"
    rounded-full
  />
  <span
    v-else
    class="size-5 grid place-content-center rounded-full bg-n-alpha-2"
    :class="{ 'bg-n-solid-blue': active }"
  >
    <ChannelIcon :inbox="inbox" class="size-3" />
  </span>
  <div class="flex-1 truncate min-w-0">{{ label }}</div>
  <div
    v-if="reauthorizationRequired"
    v-tooltip.top-end="$t('SIDEBAR.REAUTHORIZE')"
    class="grid place-content-center size-5 bg-n-ruby-5/60 rounded-full"
  >
    <Icon icon="i-woot-alert" class="size-3 text-n-ruby-9" />
  </div>
</template>
